export const Roles = {
  Admin: 'Admin',
  Manager: 'Manager',
  User: 'User',
} as const

export type Roles = (typeof Roles)[keyof typeof Roles]
